import { render, staticRenderFns } from "./exhibition-product.vue?vue&type=template&id=04d03e62&scoped=true&"
import script from "./exhibition-product.vue?vue&type=script&lang=js&"
export * from "./exhibition-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d03e62",
  null
  
)

export default component.exports